import {
  Component,
  EventEmitter,
  Input,
  Output,
  HostListener,
  ElementRef,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { DropdownItem } from './super-dropdown.component';

import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
@Component({
  selector: 'app-portal-dropdown-menu',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <ul
      class="dropdown-menu portal"
      [ngClass]="{
        'align-right': align === 'right',
        'align-left': align === 'left'
      }"
      [ngStyle]="getMenuPositionStyle()"
      tabindex="0"
    >
      <li
        *ngFor="let item of items; let i = index"
        [class.dropdown-divider]="item.divider"
        [class.dropdown-item]="!item.divider"
        [class.focused]="i === focusedIdx && !item.divider"
        (click)="!item.divider && selectItem(i)"
        [attr.tabindex]="!item.divider ? 0 : null"
      >
        <ng-container *ngIf="!item.divider">
          <mat-icon class="dropdown-icon" *ngIf="item.icon">{{
            item.icon
          }}</mat-icon>
          <span>{{ item.label }}</span>
        </ng-container>
      </li>
    </ul>
  `,
  styleUrls: ['./super-dropdown.component.css'],
})
export class PortalDropdownMenuComponent implements AfterViewInit, OnDestroy {
  getMenuPositionStyle() {
    if (!this.position) return {};
    if (this.align === 'right') {
      return {
        top: this.position.top + 'px',
        right: (this.position.right ?? 0) + 'px',
        minWidth: this.minWidth + 'px',
        left: 'auto',
      };
    } else {
      return {
        top: this.position.top + 'px',
        left: this.position.left + 'px',
        minWidth: this.minWidth + 'px',
        right: 'auto',
      };
    }
  }
  constructor() {
    console.log('[PortalDropdownMenuComponent] constructor');
  }

  ngOnInit() {
    console.log('[PortalDropdownMenuComponent] ngOnInit, items:', this.items);
  }

  ngAfterViewInit() {
    console.log('[PortalDropdownMenuComponent] ngAfterViewInit');
    this.timeoutId = setTimeout(() => {
      this.justOpened = false;
    }, 150);
  }

  ngOnDestroy() {
    console.log('[PortalDropdownMenuComponent] ngOnDestroy');
    if (this.timeoutId) clearTimeout(this.timeoutId);
  }
  @Input() items: DropdownItem[] = [];
  @Input() align: 'left' | 'right' = 'left';
  @Input() focusedIdx = -1;
  @Input() position: {
    top: number;
    left: number;
    minWidth?: number;
    right?: number;
  } | null = null;
  @Input() minWidth = 170;
  @Output() itemSelected = new EventEmitter<number>();
  @Output() closeMenu = new EventEmitter<void>();

  private justOpened = true;
  private timeoutId: any;

  selectItem(idx: number) {
    this.itemSelected.emit(idx);
  }

  @HostListener('document:mousedown', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.justOpened) return;
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown-menu')) this.closeMenu.emit();
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape') this.closeMenu.emit();
  }
}
